import { render } from "./contentPage.vue?vue&type=template&id=5452cece&scoped=true"
import script from "./contentPage.vue?vue&type=script&lang=js"
export * from "./contentPage.vue?vue&type=script&lang=js"

import "./contentPage.vue?vue&type=style&index=0&id=5452cece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5452cece"]])

export default __exports__